// import XLSX from 'xlsx';
import humanize from 'underscore.string/humanize';
import parseCSV from 'csv-parse/lib/es5/sync';

export function guessFileType(file, fileContent) {
  const scores = {
    fasta: 0,
    csv: 0,
    tsv: 0
  };
  for (const line of fileContent.split(/[\r\n]+/g)) {
    if (line.startsWith('>')) {
      scores.fasta += 2;
      scores.tsv --;
      scores.csv --;
    }
    if (/\t/.test(line)) {
      scores.tsv ++;
      scores.fasta --;
      scores.csv --;
    }
    if (/,/.test(line)) {
      scores.csv ++;
      scores.fasta --;
      scores.tsv --;
    }
    for (const type in scores) {
      if (scores[type] > 3) {
        return type;
      }
    }
  }
  const sorted = Object.entries(scores).sort(([, a], [, b]) => b - a);
  if (sorted[0][1] > sorted[1][1]) {
    return sorted[0][0];
  }
  else {
    switch(file.type) {
      case 'text/tab-separated-values': {
        return 'tsv';
      }
      case 'text/csv': {
        return 'csv';
      }
      case 'text/x-fasta': {
        return 'fasta';
      }
    }
  }
  return false;
}

export function parseCSVFile(fileContent, headers, delimiter = ',', omit_first_row = true, defaults = null) {
  let rows = parseCSV(fileContent, {
    delimiter, trim: true,
    skip_empty_lines: true,
    columns: headers
  });
  if (rows.length && omit_first_row) {
    rows.splice(0, 1);
  }
  if (defaults) {
    rows = rows.map(r => Object.assign({}, defaults, r));
  }
  return rows;
}

export function dumpTSVFile(rows, headers, fileName, enable_humanize = true) {
  let data = [];
  let _headers = headers;
  if (enable_humanize) {
    _headers = _headers.map(humanize);
  }
  data.push(_headers.join('\t'));
  for (let row of rows) {
    row = headers.map(col => {
      const v = row[col];
      if ((v !== '=' && isNaN(v)) || v === null) {
        return v;
      } else if (v === '=') {
        return `'${v}'`;
      } else {
        // prevent any strings being converted to numbers
        // Excel tsv format issue, = started number would be converted to other format.
        return `='${v}'`;
      }
    }).join('\t');
    data.push(row);
  }
  data = data.join('\n');
  download(data, 'text/tab-separated-values', fileName);
}

/* export function dumpXLSXFile(rows, headers, cellAttrs, fileName) {
  const sheet = {};
  const columns = {};
  for (let idx = 0; idx < headers.length; idx ++) {
    const header = headers[idx];
    let col = String.fromCharCode(65 + idx % 26);
    if (idx >= 26 && idx < 26 * 26) {
      col = String.fromCharCode(64 + Math.floor(idx / 26)) + col;
    }
    columns[header] = col;
    sheet[`${col}1`] = {t: 's', v: humanize(header)};
  }
  let lastCell = 'A1';
  for (let rowidx = 0; rowidx < rows.length; rowidx ++) {
    const row = rows[rowidx];
    for (let colidx = 0; colidx < headers.length; colidx ++) {
      const header = headers[colidx];
      let v = row[header];
      const col = columns[header];
      let attr = cellAttrs[header] || {t: 's'};
      v = v === null ? '' : v;
      v = typeof(v) === 'undefined' ? '' : v;
      if (v === '') {
        attr = {t: 's'};
      }
      lastCell = `${col}${rowidx + 2}`;
      sheet[lastCell] = {...attr, v, w: v};
    }
  }
  sheet['!ref'] = `A1:${lastCell}`;
  const workbook = {
    SheetNames: ["Sheet1"],
    Sheets: {Sheet1: sheet}
  };
  console.log(workbook);
  const out = XLSX.write(
    workbook,
    {
      bookType: 'xlsx', cellDates: true,
      bookSST: false, type: 'binary'
    });
  download(
    out, 'application/vnd.openxmlformats-officedocument.' +
    'spreadsheetml.sheet', fileName);
} */

export function readFile(file) {
  return new Promise((resolve) => {
    let reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => {
      resolve(reader.result);
    };
  });
}


export function download(data, fileType, fileName = undefined) {
  if (!(data instanceof Blob)) {
    data = new Uint8Array(Array.from(data).map(c => c.charCodeAt(0)));
    data = new Blob([data], {type: fileType});
  }
  if (window.navigator.msSaveOrOpenBlob) {
    // download method of IE
    window.navigator.msSaveOrOpenBlob(data, fileName);
  }
  else {
    const uri = URL.createObjectURL(data);
    downloadURI(uri, fileName);
  }
}


export function downloadURI(uri, fileName = undefined) {
  const a = document.createElement('a');
  a.style.display = 'none';
  document.body.appendChild(a);

  a.setAttribute('href', uri);
  a.setAttribute('download', fileName);
  a.click();
  setTimeout(() => document.body.removeChild(a));
}



// WEBPACK FOOTER //
// ./src/utils/file-utils.js